import { Button, IconButton, Input } from '@material-ui/core';
import React from 'react';
import CloseIcon from '../../assets/allIcons/CloseIcon';
import { StyledButtonsRow, StyledDialog, StyledDialogContent, StyledDialogTitle, StyledFormValidate, StyledHeader, StyledInputContainer, StyledSubHeader } from './SupportModal.style';

const SupportModal = ({
  open,
  onClose,
  handleSend,
  sendingLoading,

  email,
  setEmail,
  emailError,
  message,
  setMessage,
}) => {

  return (
    <StyledDialog open={open} onClose={onClose}>
      <StyledDialogTitle>
        <StyledHeader>
          Техподдержка
          <StyledSubHeader>
            Введите E-mail и сообщение
          </StyledSubHeader>
        </StyledHeader>
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </StyledDialogTitle>

      <StyledDialogContent>
        <StyledFormValidate noValidate>
          <StyledInputContainer>
            <Input
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              fullWidth
              variant="filled"
              required
              id="email"
              placeholder="E-mail*"
              type="email"
            />
          </StyledInputContainer>
          <StyledInputContainer>
            <Input
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              fullWidth
              variant="filled"
              required
              multiline
              maxRows={4}
              id="message"
              placeholder="Сообщение*"
            />
          </StyledInputContainer>
        </StyledFormValidate>


      </StyledDialogContent>

      <StyledButtonsRow>
        <Button
          fullWidth
          type="button"
          size='large'
          onClick={onClose}
        >
          отмена
        </Button>
        <Button
          fullWidth
          type="button"
          size='large'
          variant='contained'
          onClick={handleSend}
          disabled={!email || !message}
        >
          Отправить
        </Button>
      </StyledButtonsRow>
    </StyledDialog>
  )
}

export default SupportModal;
